const navLinkStyledFPC = {
  text: 'Regrese a la página de inicio para ingresar'
};

export default navLinkStyledFPC;
